<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบสมาชิกนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteMember"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayPermission">
      <div class="px-8">
        <h2 class="text-white text-center my-5">
          จัดการสิทธิการเข้าถึง
        </h2>
        <div class="flex items-baseline">
          <h4>ชื่อ :&nbsp;</h4>
          <h4>{{ companyName }}</h4>
        </div>
        <div class="flex items-center my-4">
          <h4>ประเภทแอดมิน :&nbsp;</h4>
          <select
            class="w-2/12"
            v-model="roleId"
            @change="loadFolderPermission(modalFolderId)"
          >
            <option :value="null">ALL</option>
            <option
              v-for="role in roleList"
              :key="role.role_id"
              :value="role.role_id"
              >{{ role.role_name }}</option
            >
          </select>
        </div>
        <div class="pm-table">
          <div class="grid grid-cols-12 table-header">
            <div class="col-span-1">
              <vs-checkbox
                color="#57c293"
                :value="allIsView"
                @change="setAllView($event)"
                ><p>View</p></vs-checkbox
              >
            </div>
            <div class="col-span-1">
              <vs-checkbox
                color="#57c293"
                :value="allIsEdit"
                @change="setAllEdit($event)"
                ><p>Edit</p></vs-checkbox
              >
            </div>
            <div class="col-span-1">
              <p>รหัส</p>
            </div>
            <div class="col-span-7">
              <p>ชื่อ</p>
            </div>
            <div class="col-span-2">
              <p>สถานะ</p>
            </div>
          </div>
          <div v-if="this.userToFolder.length > 0" class="pm-row">
            <div
              v-for="user in userToFolder"
              :key="user.user_id"
              class="grid grid-cols-12 table-row"
            >
              <div class="col-span-1">
                <vs-checkbox color="#57c293" v-model="user.isView"
                  ><p>View</p></vs-checkbox
                >
              </div>
              <div class="col-span-1">
                <vs-checkbox color="#57c293" v-model="user.isEdit"
                  ><p>Edit</p></vs-checkbox
                >
              </div>
              <div class="col-span-1">
                <p>{{ user.user_id }}</p>
              </div>
              <div class="col-span-7">
                <p>{{ user.name }}</p>
              </div>
              <div class="col-span-2">
                <p>{{ user.role }}</p>
              </div>
            </div>
          </div>
          <div v-else class="pm-no-row">
            <p>No Rows To Show</p>
          </div>
        </div>
        <div class="grid grid-cols-8 gap-4 mt-5">
          <vs-button
            class="col-end-8"
            color="#ffffff"
            style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
            text-color="#8d9498"
            @click="displayPermission = false"
          >
            ยกเลิก
          </vs-button>
          <vs-button class="col-end-9" @click="submitPermission" color="#15c1c3"
            >บันทึก</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <div class="contentArea">
      <div class="pl-2">
        <div>
          <!-- <topTableButton /> -->
          <!-- <tabComponent /> -->
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div>
                <vs-button
                  v-if="permission.user_add"
                  color="#15c1c3"
                  style="width: 160px;"
                  @click="goToCreateMember"
                >
                  <font-awesome-icon icon="plus" class="mr-1" />
                  เพิ่มสมาชิก
                </vs-button>
              </div>
              <div class="flex">
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      displayDelete: false,
      displayPermission: false,
      deleteId: null,
      searchTerm: "",
      modalFolderId: null,
      userToFolder: [],
      roleList: [],
      roleId: null,
      companyName: "",
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    allIsView() {
      return this.userToFolder.every((v) => v.isView === true);
    },
    allIsEdit() {
      return this.userToFolder.every((v) => v.isEdit === true);
    },
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    async confirmDeleteMember() {
      const res = await axios.post(
        `${baseUrl}/member/delete?detail_id=${this.deleteId}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.$store.dispatch("general/getTable", "fifth");
      this.displayDelete = false;
    },
    goToCreateMember() {
      this.$router.push("/createmember");
    },
    setAllView(e) {
      if (e.target.checked) {
        for (const user of this.userToFolder) {
          user.isView = true;
        }
      } else {
        for (const user of this.userToFolder) {
          console.log(user.role);
          user.isView = false;
        }
      }
    },
    setAllEdit(e) {
      if (e.target.checked) {
        for (const user of this.userToFolder) {
          user.isEdit = true;
        }
      } else {
        for (const user of this.userToFolder) {
          user.isEdit = false;
        }
      }
    },
    async submitPermission() {
      console.log(this.userToFolder);
      const permissionData = [];
      for (const user of this.userToFolder) {
        permissionData.push({
          user_id: user.user_id,
          folder_id: this.modalFolderId,
          isView: user.isView,
          isEdit: user.isEdit,
        });
      }
      try {
        const res = await axios.post(
          `${baseUrl}/file/folder`,
          {
            user: permissionData,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
      } catch (err) {
        alert(err);
      }
      this.modalFolderId = null;
      this.userToFolder = [];
      this.displayPermission = false;
    },
    async loadFolderPermission(id) {
      this.isLoading = true;
      this.modalFolderId = id;
      if (this.roleId) {
        const res = await axios.get(
          `${baseUrl}/file/folder/get?folder_id=${id}&role_id=${this.roleId}`,
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        this.userToFolder = res.data.data;
      } else {
        const res = await axios.get(
          `${baseUrl}/file/folder/get?folder_id=${id}`,
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        this.userToFolder = res.data.data;
      }
      this.isLoading = false;
      this.displayPermission = true;
    },
    async loadRoleList() {
      const res = await axios.get(`${baseUrl}/role/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      console.log(res.data.data);
      this.roleList = res.data.data;
    },
  },
  mounted() {
    this.$root.$on("delete-modal", (id) => {
      this.displayDelete = true;
      this.deleteId = id;
    });
    this.$root.$on("show-table", ({ id, company }) => {
      this.companyName = company;
      this.loadFolderPermission(id);
    });
    // this.$store.dispatch("general/getTab", this.nowSlug);
    this.$store.dispatch("general/getMemberTable", {
      path: this.tabActive.path || this.nowSlug,
      roleId: this.$store.getters.getRoleId,
    });
  },
  watch: {
    tabActive(newValue) {
      this.$store.dispatch("general/getTable", newValue.path);
    },
  },
  created() {
    this.loadRoleList();
  },
};
</script>

<style scoped>
h4 {
  color: #fff;
}

p {
  color: #fff;
}

select {
  height: 34px;
  border-radius: 2px;
  padding-left: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #434f5b;
  border: none;
}

.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}
.pm-table {
  background-color: #4e5363;
  padding: 10px;
  border-radius: 5px;
}

.pm-row {
  overflow-y: scroll;
  height: 200px;
}

.pm-no-row {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pm-row::-webkit-scrollbar {
  display: none;
}

.table-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #8d9498;
}

.table-row {
  padding: 10px 0;
  border-bottom: 1px solid #3a3f51;
}

.table-row:hover {
  background-color: #656b81;
}
</style>
